module.exports = __webpack_public_path__ + "static/media/dinosaur(17).1ca4de74.PNG";